import type { ButtonProps } from '@mui/material/Button';

import { useAuth0 } from '@auth0/auth0-react';

import Button from '@mui/material/Button';

import { setAxiosToken } from 'src/lib/axios-store';
import { handleSessionLogout } from 'src/observability/datadog-helpers';

import { useHRAuth } from 'src/auth/hooks/use-hr-context';
import { useStoreLocalStorage } from 'src/auth/hooks/use-store-localStorage';

// ----------------------------------------------------------------------

type Props = ButtonProps & {
  onClose?: () => void;
};

export function SignOutButton({ onClose, sx, ...other }: Props) {
  const { logout } = useAuth0();
  const { clearRefreshTimeout } = useHRAuth();
  const { saveValue: saveCustomToken } = useStoreLocalStorage('customToken', '');
  const { saveValue: saveCustomRefreshToken } = useStoreLocalStorage('customRefreshToken', '');
  const { saveValue: saveCustomTokenExpiry } = useStoreLocalStorage('customTokenExpiry', '');
  const { saveValue: saveHRContext } = useStoreLocalStorage('hrContext', '');
  const { saveValue: saveAuth0AccessToken } = useStoreLocalStorage('auth0AccessToken', '');

  const handleLogout = async () => {
    try{
      //destroyProductFruits();
      logout({
        logoutParams: {
          returnTo: window.location.origin
        }
      });
      handleSessionLogout();
      saveCustomToken('');
      saveCustomRefreshToken('');
      setAxiosToken(null);
      saveCustomTokenExpiry('');
      saveHRContext('');
      saveAuth0AccessToken('');
      clearRefreshTimeout();
    }catch(error){
      console.error(error);
    }
  };

  return (
    <Button
      fullWidth
      variant="soft"
      size="large"
      color="error"
      onClick={handleLogout}
      sx={sx}
      {...other}
    >
      Logout
    </Button>
  );
}
